import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WarehouseMapApiAdapter } from '../adapters/WarehouseMapApiAdapter';

export const useWarehouses = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WarehouseMapApiAdapter(httpClient);

  return useQuery({
    queryKey: ['warehouses'],
    queryFn: () => adapter.getWarehouses(),
    staleTime: 5 * 60 * 1000,
  });
};
